import GlobalFields from 'defs/ga/fields/global';
import { LastDayOfProgram } from '../fields/programFeedView';

export const trackLastDay = ({
	programName,
	action,
	programStart,
	programEnd,
	programDuration,
	language,
	levelStatus,
	levelPoints,
}: {
	programName?: string;
	action: string;
	programStart: string;
	programEnd: string;
	programDuration: string;
	language: string;
	levelStatus: string;
	levelPoints: string;
}) => ({
	[GlobalFields.Event]: 'coach_programm',
	[LastDayOfProgram.ProgramName]: programName,
	[LastDayOfProgram.Action]: action,
	[LastDayOfProgram.ProgramStart]: programStart,
	[LastDayOfProgram.ProgramEnd]: programEnd,
	[LastDayOfProgram.ProgramDuration]: programDuration,
	[LastDayOfProgram.Language]: language,
	[LastDayOfProgram.LevelStatus]: levelStatus,
	[LastDayOfProgram.LevelPoints]: levelPoints,
});
